import { useMemo } from 'react';

import { Demand } from '@work4all/models/lib/Classes/Demand.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { EntityTableV8, IEntityTableV8 } from './entity-table/EntityTableV8';
import { useEntityDataTableV8 } from './entity-table/use-entity-data-table-v8';
import { useErpTable } from './offers-table/erp-common/use-erp-table';
import { useCloneConvertErpActions } from './offers-table/hooks/use-clone-convert-erp';
import schema from './schemata/demand-table-schema.json';
import { useErpHandlersTemplateV8 } from './use-erp-handlers-template-v8';

const defaultSort = [{ field: 'date', direction: SortDirection.DESCENDING }];

const secondarySort = [
  { field: 'number', direction: SortDirection.DESCENDING },
];

export function DemandsTable(props: IEntityTableV8) {
  const dataTable = useEntityDataTableV8<Demand, never>({
    ...props,
    schema: schema as never,
    defaultSort,
    secondarySort,
    rowModifiers: (value) => {
      return {
        isFaded: value.isClosed && value.frozen,
        isShade1: !value.isClosed && value.frozen,
      };
    },
  });

  const template = useErpHandlersTemplateV8(dataTable.table);

  useErpTable(Entities.demand, dataTable.data.length === 0);

  const { actions } = useCloneConvertErpActions({
    entity: Entities.demand,
    data: dataTable.selectedEntities,
  });

  const custom = useMemo(
    () => ({
      left: actions,
    }),
    [actions]
  );

  return (
    <EntityTableV8
      {...props}
      {...dataTable}
      template={template}
      actions={{ custom }}
    />
  );
}
